import $ from 'jquery';
import Highcharts from 'highcharts/es-modules/masters/highcharts.src';
import 'highcharts/es-modules/masters/modules/accessibility.src';
import 'highcharts/es-modules/masters/modules/exporting.src';
import 'highcharts/es-modules/masters/modules/offline-exporting.src';
import '@/lib/highcharts_checkbox_position';

$(function() {
  // set DEFAULT chart options
  Highcharts.setOptions({
    lang: {
      numericSymbols: ['k', 'M', 'B', 'T', 'P', 'E'],
      thousandsSep: ',',
    },
    credits: {
      enabled: false
    },
    chart: {
      height: 245,
      backgroundColor: null,
      plotBackgroundColor: null,
    },
    // using default colors from version 3.x
    colors: [
      '#2f7ed8',
      '#0d233a',
      '#8bbc21',
      '#910000',
      '#1aadce',
      '#492970',
      '#f28f43',
      '#77a1e5',
      '#c42525',
      '#a6c96a',
    ],
    title: {
      style: {
        color: '#666',
        fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
        fontSize: '14px'
      }
    },
    navigation: {
      menuItemStyle: {
        padding: '0 .5em',
      },
    },
    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'middle',
      backgroundColor: 'none',
      borderColor: 'none',
      borderWidth: 0,
      itemStyle: {'color': '#444', 'fontWeight': 'normal'},
      itemHoverStyle: {color: '#aaa'},
      itemMarginBottom: 10,
      symbolRadius: 0,
      y: 15,
    },
    plotOptions: {
      series: {},
    },
    exporting: {
      sourceWidth: 850,
      buttons: {
        contextButton: {
          text: 'Download',
          x: 5,
          y: -10,
          theme: {
            fill: '#fff',
            r: 5,
            padding: 5,
            states: {
              hover: {stroke: '#7a7a7a', fill: '#fff'},
              select: {stroke: '#7a7a7a', fill: '#fff'}
            }
          },
          menuItems:[
            "printChart",
            "separator",
            "downloadPNG",
            "downloadPDF",
            "downloadSVG"
          ],
        }
      },
      // FIXME: Remove if Highcharts fixes this bug:
      // https://github.com/highcharts/highcharts/issues/21277 (Or update when
      // we do major version bumps if the bug remains).
      libURL: 'https://code.highcharts.com/12/lib/',
    },
    yAxis: {
      gridLineColor: '#c0c0c0',
    },
  });

  // set ELECTRICITY SOURCES chart options
  var electricitySourcesChartOptions = {
    chart: {
      renderTo: 'electricitySourcesChart',
      height: 325,
    },
    title: {
      text: `Electricity Sources <br>in ${window.stateName}`,
      align: 'left'
    },
    legend: {
      itemStyle: {fontSize: '10px'},
      verticalAlign: 'middle',
      labelFormatter: function () {
        return '<b>' + this.name + '</b>: ' + this.y.toFixed(2) + '%';
      },
      itemMarginTop: 1, // top legend item was getting cut off by navigation
    },
    series: [
      {
        type: 'pie',
        data: window.electricitySourcesData
      }
    ],
    plotOptions: {
      pie: {
        allowPointSelect: true,
        cursor: 'pointer',
        dataLabels: {
          enabled: false
        },
        showInLegend: true
      },
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.point.name + '</b>: ' + Highcharts.numberFormat(this.y, 2) + '%';
      }
    },
    exporting: {
      enabled: false
    }
  };

  // set ELECTRIC VEHICLE EMISSIONS chart options
  var electricVehicleEmissionsChartOptions = {
    chart: {
      renderTo: 'electricVehicleEmissionsChart',
      type: 'column',
      height: 325,
    },
    title: {
      text: "Annual Emissions per Vehicle",
    },
    series: [
      { name: 'Electric emissions', data: window.electricVehicleEmissionsElectricData, color: '#2db262'},
      { name: 'Gasoline emissions', data: window.electricVehicleEmissionsGasData, color: '#999999' }
    ],
    tooltip: {
      formatter: function () {
        var pointName = this.point.category;
        var pointValue = Highcharts.numberFormat(this.point.y, 0);
        var phevElectric = window.electricVehicleEmissionsElectricData[1];
        var phevElectricFormatted = Highcharts.numberFormat(phevElectric, 0);
        var phevGas = window.electricVehicleEmissionsGasData[1];
        var phevGasFormatted = Highcharts.numberFormat(phevGas, 0);
        var phevTotal = phevElectric + phevGas;
        var phevTotalFormatted = Highcharts.numberFormat(phevTotal, 0);
        if (this.point.x === 1) {
          return `<b>${pointName}</b><br>${phevTotalFormatted}</b> pounds <br> of CO<sub>2</sub> equivalent <br>(${phevElectricFormatted} from electric <br> and ${phevGasFormatted} from gasoline)`;
        } else {
          return `<b>${pointName}</b><br> ${pointValue} pounds <br> of CO<sub>2</sub> equivalent`;
        }
      },
    },
    plotOptions: {
      column: {
        stacking: 'normal',
      },
    },
    showInLegend: true,
    legend: {
      margin: 3,
      padding: 3,
      itemDistance: 8,
      itemStyle: {fontSize: '10px'},
      layout: 'horizontal',
      verticalAlign: 'bottom',
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Pounds of CO<sub>2</sub> Equivalent',
        style: {
          color: '#666',
          fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
          fontSize: '10px',
          fontWeight: 'normal'
        }
      }
    },
    xAxis : {
      title: {
        text: 'Light-duty vehicles excluding fuel cell electric',
        style: {
          color: '#666',
          fontFamily: '"Montserrat", Helvetica, sans-serif',
          fontSize: '10px',
        },
      },
      categories: ['All Electric', 'Plug-in Hybrid', 'Hybrid', 'Gasoline'],
      crosshair: true,
      tickWidth: 1,
      labels: {
        autoRotation: false,
        style: {
          fontSize: '10px',
        }
      },
    },
    exporting: {
      enabled: false
    }
  };

  // set FUEL CONSUMPTION chart options
  var fuelConsumptionChartOptions = {
    chart: {
      renderTo: 'fuelConsumptionChart',
      height: 400,
    },
    title: {
      text: `Gasoline Fuel Consumption in ${window.stateName}`,
    },
    series: [
      {
        name: 'Gasoline',
        data: window.gasolinedata
      }
    ],
    plotOptions: {
      series: {
        pointInterval: 1,
        pointStart: 1960
      }
    },
    tooltip: {
      headerFormat: '',
      pointFormat: '<b>{point.y} GGEs</b> in {point.x}'
    },
    legend: {
      enabled: false
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Gasoline Gallon Equivalents',
        style: {
          color: '#666',
          fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
          fontSize: '12px',
          fontWeight: 'normal'
        }
      }
    },
  };

  // set FUEL PRICES chart options
  var fuelPricesChartOptions = {
    chart: {
      renderTo: 'fuelPricesChart',
      height: 450,
    },
    title: {
      text: `Average Fuel Prices for the ${window.regionName} PADD`,
    },
    legend: {
      margin: 30,
    },
    series: window.fuelPricesData,
    plotOptions: {
      series: {
        showCheckbox: true,
        selected: true,
        events: {
          checkboxClick: function() {
            if(this.visible) {
              this.hide();
            } else {
              this.show();
            }
            return false;
          },
          hide: function() {
            $(this.checkbox).prop('checked', false);
          },
          show: function() {
            $(this.checkbox).prop('checked', true);
          }
        }
      }
    },
    tooltip: {
      formatter: function() {
        return '<b>' + this.series.name +'</b><br>' + Highcharts.dateFormat('%b %Y', new Date(this.point.key)) + '<br><b>$' + this.y + '</b> per GGE';
      }
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Dollars per GGE',
        style: {
          color: '#666',
          fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
          fontSize: '12px',
          fontWeight: 'normal'
        }
      }
    },
    xAxis: {
      type: 'datetime'
    },
    exporting: {
      enabled: false
    }
  };

  // render ELECTRICITY SOURCES chart
  new Highcharts.Chart(electricitySourcesChartOptions);

  // render ELECTRIC VEHICLE EMISSIONS chart
  new Highcharts.Chart(electricVehicleEmissionsChartOptions);

  // render FUEL PRICES chart
  new Highcharts.Chart(fuelPricesChartOptions);

  // render FUEL CONSUMPTION chart
  new Highcharts.Chart(fuelConsumptionChartOptions);

  // switch FUEL CONSUMPTION chart on dropdown select
  $('select#states-fuel-consumption-toggle').change(function() {
    // Deep copy
    var options = $.extend(true, {}, fuelConsumptionChartOptions);

    var fuelKey = $(this).val();
    var fuelData = window[fuelKey + 'data'];
    var fuelName = $('option[value="' + fuelKey + '"]').text();
    if (fuelKey === 'propane') {
      options.plotOptions.series.pointStart = 2010;
    }
    options.series = [{name: fuelName, data: fuelData}];
    options.title.text = `${fuelName} Fuel Consumption in ${window.stateName}`;
    new Highcharts.Chart(options);
  });
});
